module.exports = __webpack_public_path__ + "static/media/T5-01.dd03bb6c.svg";